import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { BaseComponent } from '../../../../core/layout/components/abstracts/base.component';
import { ConfirmationDirective } from '../../../../shared/directives/confirmation.directive';
import { TooltipDirective } from '../../../../shared/directives/tooltip.directive';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { LocaleDatetimeFormatPipe } from '../../../../shared/pipes/locale-datetime-format.pipe';
import { EmptyPipe } from '../../../../shared/pipes/empty.pipe';
import { CardsService } from '../../core/services/CardsService';
import { ICard } from '../../core/interfaces/ICard';
import { ApiErrorResponse } from '../../../../core/classes/ApiErrorResponse';
import { AddProductsModalComponent } from '../../modals/add-products-modal/add-products-modal.component';
import { SwitchComponent } from '../../../../shared/components/switch/switch.component';
import { FormsModule } from '@angular/forms';
import { ArrayFilterPipe } from '../../../../shared/pipes/array-filter.pipe';
import { ICardProduct } from '../../core/interfaces/ICardProduct';
import { ArraySortByKeyPipe } from '../../../../shared/pipes/array-sort-by-key.pipe';

@Component({
  selector: 'app-card-products-table',
  standalone: true,
  imports: [
    ConfirmationDirective,
    TooltipDirective,
    TranslatePipe,
    LocaleDatetimeFormatPipe,
    EmptyPipe,
    AddProductsModalComponent,
    SwitchComponent,
    FormsModule,
    ArrayFilterPipe,
    ArraySortByKeyPipe
  ],
  templateUrl: './card-products-table.component.html',
  styleUrl: './card-products-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardProductsTableComponent extends BaseComponent {

  @Input({ required: true }) card: ICard;

  @Output() cardUpdated = new EventEmitter<ICard>();

  public showUsedItems = false;
  public readonly excludeUsedItems = (x: ICardProduct) => !!!x.dateUsed;
  public readonly excludeUnusuedItems = (x: ICardProduct) => !!x.dateUsed;

  private readonly _cardsService = inject(CardsService)

  public deleteProductFromCard(cardProductId: number): void {
    this._cardsService.deleteProductFromCard(this.card.cardId, cardProductId)
      .pipe()
      .subscribe({
        next: res => this.cardUpdated.emit(res.data),
        error: ({ error }: ApiErrorResponse) => {
          this.notificationService.pushError(
            'Fehler'.trans('notifications/error.Title'),
            error.message.trans(`delete-product-from-card/notifications/${error.message}.Message`)
          );
        }
      });
  }
}
